<template>
  <!-- 导入供应商 -->
  <div>
    <Modal v-model="visible" width="700px" title="导入供应商" :footer-hide="true" :mask-closable="false" class="my-modal">
      <Form ref="form" :model="formData" :label-width="90" class="page-form less">
        <FormItem prop="dataType" label="供应商类型" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.dataType" @on-change="changeDataType">
            <Option value="1">保司</Option>
            <Option value="2">合作通道</Option>
          </Select>
        </FormItem>
        <FormItem prop="companyType" label="公司性质" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.companyType" @on-change="changeCompany">
            <Option value="1">总公司</Option>
            <Option value="2">分公司</Option>
          </Select>
        </FormItem>
        <FormItem v-if="formData.companyType == 2" class="full" prop="parentChannelIds" label="所属总公司" :rules="$units.formRule.arrRequired('请选择')">
          <Select v-model="formData.parentChannelIds" @on-change="changeParentCompany" filterable clearable transfer>
            <Option :value="item.id" v-for="item in parentCompanyList" :key="item.id">{{ item.fullName }}</Option>
          </Select>
        </FormItem>
        <FormItem class="full" prop="channelIds" :label="formData.dataType == 1 ? '保司' : '合作通道'" :rules="$units.formRule.arrRequired('请选择')">
          <Select v-model="formData.channelIds" :multiple="true" :max-tag-count="2" filterable clearable transfer>
            <Option :value="item.id" v-for="item in companyList" :key="item.id">{{ item.fullName }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>
  
<script>
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      parentCompanyList: [], //所属总公司
      companyList: [] //保险公司
    };
  },
  computed: {},
  created() {},
  methods: {
    open() {
      if(!this.$units.pointAction('pro_7_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.formData = {
        companyType: '',
        dataType: '1', //1保司 2合作通道
        parentChannelIds: [],// 所属总公司
        channelIds: [],//供应商
      };
      this.visible = true;
      this.queryCompany();
      this.$refs.form &&
        this.$refs.form.fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
    },
    clearInfo(){
      this.$refs.form &&
        this.$refs.form.fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
    },
    // 切换供应商类型
    changeDataType(){
      this.formData.channelIds = [];
      this.formData.parentChannelIds = [];
      this.formData.companyType = '';
      this.clearInfo();
    },
    // 查询公司
    queryCompany() {
      let url = '';
      const params = {
        pageNo: 1,
        pageSize: 9999
      };
      if (this.formData.dataType == 1) {
        params.companyType = this.formData.companyType;
        url = '/buz/insuranceCompany/queryAdd';
      } else {
        params.channelType = this.formData.companyType;
        url = '/buz/insuranceChannel/queryAdd';
      }
      this.$http({
        url: url,
        type: 'POST',
        data: params
      }).then(res => {
        this.companyList = res.data;
      });
    },

    // 切换公司性质
    changeCompany(value) {
      this.formData.channelIds = [];
      if (value == 1) {
        this.queryCompany();
      } else {
        this.companyList = [];
        let url = '';
        const params = {};
        if (this.formData.dataType == 1) {
          params.companyType = 1;
          url = '/buz/insuranceCompany/read/list';
        } else {
          params.channelType = 1;
          url = '/buz/insuranceChannel/read/list';
        }
        this.$http({
          url: url,
          type: 'POST',
          data: params
        }).then(res => {
          this.parentCompanyList = res.data;
        });
      }
    },

    // 选中所属总公司,查询通道公司
    changeParentCompany(value) {
      let url = '';
      const params = {
        parentId: value,
        pageNo: 1,
        pageSize: 9999
      };
      if (this.formData.dataType == 1) {
        params.companyType = 2;
        url = '/buz/insuranceCompany/queryAdd';
      } else {
        params.channelType = 2;
        url = '/buz/insuranceChannel/queryAdd';
      }
      this.$http({
        url: url,
        type: 'POST',
        data: {
          channelType: '2',
          parentId: value,
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    cancel() {
      this.visible = false;
    },
    submit() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }
        const data = {};
        if(this.formData.dataType == 1){
          data.companyIds = this.formData.channelIds
        }else{
          data.channelIds = this.formData.channelIds
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          url: this.formData.dataType == 1 ? '/buz/merchantCompanyJoin/add' : '/buz/orgChannelJoin/add',
          type: 'POST',
          data
        })
          .then(res => {
            this.$notice.success('导入成功');
            this.visible = false;
            this.$emit('reload');
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
</style>  